import { render, staticRenderFns } from "./AreaEventHistorySettingsForm.vue?vue&type=template&id=72f72f66&scoped=true"
import script from "./AreaEventHistorySettingsForm.vue?vue&type=script&lang=ts"
export * from "./AreaEventHistorySettingsForm.vue?vue&type=script&lang=ts"
import style0 from "./AreaEventHistorySettingsForm.vue?vue&type=style&index=0&id=72f72f66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f72f66",
  null
  
)

export default component.exports